/**
 * Helper: Loaders
 * -----------------------------------------------------------------------------
 * Store for loader markup.
 * - https://github.com/ConnorAtherton/loaders.css
 * - https://connoratherton.com/loaders
 */
export default {
  ballPulse: "\n    <div class=\"loader\">\n      <div class=\"ball-pulse\">\n        <div></div>\n        <div></div>\n        <div></div>\n      </div>\n    </div>\n  "
};